import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { BsTelephoneFill, BsChevronDown } from 'react-icons/bs';
import logoImage from '../assets/images/logo_top_conduite.jpg';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isResourcesOpen, setIsResourcesOpen] = useState(false);
  const location = useLocation();
  const resourcesRef = useRef(null);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const toggleResources = () => {
    setIsResourcesOpen(!isResourcesOpen);
  };

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  const isResourcesActive = () => {
    return location.pathname === '/infos-utiles' || location.pathname === '/questionnaire-satisfaction';
  };

  // Fermer le menu déroulant si on clique en dehors
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (resourcesRef.current && !resourcesRef.current.contains(event.target)) {
        setIsResourcesOpen(false);
      }
    };

    if (isResourcesOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isResourcesOpen]);

  // Fermer le menu déroulant quand on change de page
  useEffect(() => {
    setIsResourcesOpen(false);
  }, [location.pathname]);

  return (
    <header className="header">
      <div className="header-container">
        <Link to="/" className="logo">
          <img src={logoImage} alt="Top Conduite" className="logo-image" />
          <span>Top Conduite</span>
        </Link>

        <nav className={`nav ${isMenuOpen ? 'nav-open' : ''}`}>
          <Link to="/" className={`nav-link ${isActive('/')}`} onClick={() => setIsMenuOpen(false)}>
            Accueil
          </Link>
          <Link to="/formations" className={`nav-link ${isActive('/formations')}`} onClick={() => setIsMenuOpen(false)}>
            Formations
          </Link>
          <Link to="/avis" className={`nav-link ${isActive('/avis')}`} onClick={() => setIsMenuOpen(false)}>
            Avis
          </Link>
          
          {/* Menu déroulant Ressources */}
          <div className="nav-dropdown" ref={resourcesRef}>
            <button 
              className={`nav-link nav-dropdown-toggle ${isResourcesActive() ? 'active' : ''}`}
              onClick={toggleResources}
              aria-expanded={isResourcesOpen}
              aria-haspopup="true"
              type="button"
            >
              Ressources
              <BsChevronDown className={`dropdown-icon ${isResourcesOpen ? 'open' : ''}`} />
            </button>
            <div className={`dropdown-menu ${isResourcesOpen ? 'open' : ''}`}>
              <Link 
                to="/infos-utiles" 
                className={`dropdown-link ${isActive('/infos-utiles')}`}
                onClick={() => {
                  setIsMenuOpen(false);
                  setIsResourcesOpen(false);
                }}
              >
                Infos utiles
              </Link>
              <Link 
                to="/questionnaire-satisfaction" 
                className={`dropdown-link ${isActive('/questionnaire-satisfaction')}`}
                onClick={() => {
                  setIsMenuOpen(false);
                  setIsResourcesOpen(false);
                }}
              >
                Questionnaire
              </Link>
            </div>
          </div>

          <Link to="/contact" className={`nav-link ${isActive('/contact')}`} onClick={() => setIsMenuOpen(false)}>
            Contact
          </Link>
        </nav>

        <div className="header-contact">
          <a href="tel:0952655019" className="phone-link">
            <BsTelephoneFill className="phone-icon" />
            <span className="phone-number">09 52 65 50 19</span>
          </a>
          <Link to="/contact" className="btn btn-orange header-cta">
            Nous Contacter
          </Link>
        </div>

        <button className="menu-toggle" onClick={toggleMenu} aria-label="Toggle menu">
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </header>
  );
};

export default Header;
